export const SECURITY_TIMER_SECONDS = 30;
export const SESSION_LENGTH_MINUTES = 30;
export const SESSION_IDLE_BEGINS_SECONDS = 1;
//minutes remaining before renewing
export const SESSION_RENEW_THRESHOLD = 5;

export const SUPPORT_USERNAME = 'food';
export const MILISECONDS_TO_SECONDS = 1000;



// WEBPACK FOOTER //
// ./src/common/Constants/security.js